<template>
  <div class="baniere md:pb-32 pb-20">
    <div class="md:flex mt-10">
      <div class="bloc1 pt-4">
        <divider
          :height="diviserHeight"
          :color="diviserColor"
          data-aos="fade-right"
          data-aos-duration="2000"
        />
        <div
          class="titre w-full mt-5"
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          Postes disponibles
        </div>
      </div>

      <div class="bloc2 md:pl-10 md:mt-0 mt-4">
        <services
          v-for="(item, index) in postes"
          :key="index"
          :postes="item"
          @oga="retourPost"
        />
      </div>
    </div>
  </div>
</template>

<script>
import divider from '@/components/helper/divider'
import services from './services'
import metier from './metier.json'

export default {
  name: 'Index',
  components: {
    divider,
    services
  },
  props: {
  },
  data () {
    return {
      diviserColor: '#9FB4FE',
      diviserHeight: '5px',
      diviserColor1: '#D3D9EB',
      diviserHeight1: '1px',
      postes: metier,
      selectedItem: null
    }
  },
  created () {
  },
  methods: {
    retourPost (answer) {
      this.selectedItem = answer
      this.$emit('oga', this.selectedItem)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/style/sass/variables";
.baniere{
  height: auto ;
  background-color: $white;
  position: relative;
  padding-left: $padding-l;
  padding-right: $padding-r;
}
.bloc1{
  width: 32%;
}
.bloc2{
  width: 68%;
  font-weight: bold;
  font-size: 24px;
  line-height: 160%;
}

.titre{
  font-weight: 800;
  font-size: 40px;
  line-height: 150%;
  letter-spacing: 0.01em;
  color: $black
}
.titre1{
  font-weight: 800;
  font-size: 24px;
  line-height: 150%;
  letter-spacing: 0.01em;
  color: $dev_green;
}
.title3{
  font-weight: 400;
  color: $black;
}
@media screen and (max-width: 600px){
  .baniere{
    padding-left: 20px;
    padding-right: 20px;
  }
  .titre{
    font-size: 28px;
  }
  .bloc1{
    width: 100%;
  }
  .bloc2{
    width: 100%;
    font-size: 18px;
  }
  .titre1{
    font-size: 20px;
  }
  .title3{
    font-size: 18px;
  }
}
@media screen and (min-width: 701px) and (max-width: 1024px){
  .baniere{
    padding-left: $padding-l-1024;
    padding-right: $padding-r-1024;
  }
  .titre{
    font-size: 30px;
  }
  .blocc {
    padding: 30px;
  }
}
</style>
